<script setup>
import {computed} from "vue";

defineEmits(['dismiss']);

const props = defineProps({
  type: {
    type: String,
    default: 'info',
    validate: (value) => {
      return ['info', 'success', 'caution', 'danger'].includes(value);
    },
  },
  dismissable: {
    type: Boolean,
    default: false,
  }
});

const classes = computed(() => {
  return {
    'tw-bg-info-100 tw-text-info-900 tw-border-info': props.type === 'info',
    'tw-bg-success-100 tw-text-success-900 tw-border-success': props.type === 'success',
    'tw-bg-caution-100 tw-text-caution-900 tw-border-caution': props.type === 'caution',
    'tw-bg-danger-100 tw-text-danger-700 tw-border-danger': props.type === 'danger',
    'tw-relative': props.dismissable
  };
});
</script>

<template>
  <div
    class="tw-flex tw-gap-8 tw-border tw-p-8 tw-rounded-lg tw-border-l-4"
    :class="classes"
  >
    <slot />

    <svg-vue
      v-if="dismissable"
      icon="icons/close"
      class="tw-absolute tw-cursor-pointer tw-w-2 tw-h-2 tw-top-3 tw-right-3"
      @click="$emit('dismiss')"
    />
  </div>
</template>
